/**
 * Get the correct base URL for redirects based on environment
 * Uses production URL in production, localhost in development
 */
export const getRedirectOrigin = (): string => {
  const isProduction = process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost';
  
  if (isProduction) {
    return process.env.REACT_APP_PRODUCTION_URL || window.location.origin;
  }
  
  return window.location.origin;
};

/**
 * Get the full redirect URL for OAuth and email confirmations
 */
export const getRedirectUrl = (path: string): string => {
  const origin = getRedirectOrigin();
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
};